import React from "react";
import { Route, Switch } from "react-router-dom";
import { useSelector, shallowEqual } from "react-redux";
import { useHistory } from "react-router";

// Containers
const TheLayout = React.lazy(() => import("../containers/TheLayout"));

// Pages
const Login = React.lazy(() => import("../views/pages/login/Login"));
const RequestView = React.lazy(() => import("./pages/requestView/RequestView"));
const ShippingInfo = React.lazy(() => import("./pages/requestView/ShippingInfo"));
const ProofView = React.lazy(() => import("./pages/proofView/ProofView"));
const ThanksPage = React.lazy(() => import("./pages/success/ResponseSuccess"));
const UploadSampleFile = React.lazy(() => import("./pages/upload-file/UploadSampleFile"));
const Page404 = React.lazy(() => import("../views/pages/page404/Page404"));
const Page500 = React.lazy(() => import("../views/pages/page500/Page500"));
const VerifyOtp = React.lazy(() => import("../views/pages/login/VerifyOtp"));
const EstimatePayment = React.lazy(() =>
  import("../views/payment/EstimatePayment")
);

export default function MainRoute() {
  let history = useHistory();
  const { isAuthorized, path } = useSelector(
    ({ auth }) => ({
      isAuthorized: auth.user != null,
      path: auth.path,
    }),
    shallowEqual
  );

  if (isAuthorized && path) {
    history.push(path);
  }

  return (
    <Switch>
      <Route
        exact
        path="/login"
        name="Login Page"
        render={(props) =>
          isAuthorized ? history.push("/") : <Login {...props} />
        }
      />
      <Route
        exact
        path="/auth/user/verify"
        name="Verify Otp Page"
        render={(props) => <VerifyOtp {...props} />}
      />
      <Route
        exact
        path="/requestView/:requestId"
        name="Request View Page"
        render={(props) => <RequestView {...props} />}
      />
      <Route
        exact
        path="/shippingInfo/:requestId"
        name="Shipping Info Page"
        render={(props) => <ShippingInfo {...props} />}
      />
      <Route
        exact
        path="/viewProofFile/:requestId"
        name="Proof View Page"
        render={(props) => <ProofView {...props} />}
      />

      <Route
        exact
        path="/payment/estimatePayment"
        name="Estimate Payment Page"
        render={(props) => <EstimatePayment {...props} />}
      />
      <Route
        exact
        path="/response-success"
        name="Response success Page"
        render={(props) => <ThanksPage {...props} />}
      />
      <Route
        exact
        path="/proof-response-success"
        name="Response success Page"
        render={(props) => <ThanksPage {...props} />}
      />
      <Route
        exact
        path="/upload-sample-files/:requestId"
        name="Upload File "
        render={(props) => <UploadSampleFile {...props} />}
      />
      <Route
        exact
        path="/404"
        name="Page 404"
        render={(props) => <Page404 {...props} />}
      />
      <Route
        exact
        path="/500"
        name="Page 500"
        render={(props) => <Page500 {...props} />}
      />
      <Route
        path="/"
        name="Home"
        render={(props) =>
          isAuthorized ? <TheLayout {...props} /> : history.push("/login")
        }
      />
    </Switch>
  );
}
